import * as React from "react";
import { Row, Col, Form, Modal, Button } from "antd";
import { PbrInput } from "src/components/common/PbrInput/PbrInput";
import { FormComponentProps } from "antd/lib/form";
import StandardButton from "src/components/common/StandardButton/StandardButton";
import { ParagraphMedium } from "src/components/common/Paragraphs/Paragraphs";
import { AuthContext } from "src/components/context/AuthContext";
import { RouteComponentProps, withRouter, Link } from "react-router-dom";
import { ContainerWrapper } from "src/components/common/ContainerWrapper/ContainerWrapper";
import ChangePasswordRequired from "src/pages/login/RequestRecoveryCode";
import EmailConfirm from "./EmailConfirm";
import ChangePasswordByCode from "src/pages/password-recover/ChangePasswordByCode";
import { Arrow } from "src/components/common/Icons";

import * as LogoText from "src/assets/logos/precatorios-brasil/logo.svg";

import "./login.scss";
import { PbrCard } from "src/components/common/PbrCard/PbrCard";
import { useContext, useEffect, useState } from 'react';
import { ServiceContext } from 'src/services/provider/Service.provider';
import { ICommonDomain } from 'src/services/interfaces/UserInterface';
import { ShowNotification } from 'src/components/common/ShowNotification/ShowNotification';

function Login(props: RouteComponentProps<any> & FormComponentProps) {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  const [passwordRequired, setPasswordRequired] = useState(false);
  const [newPasswordRequiredUser, setNewPasswordRequiredUser] = useState(null);
  const [confirmEmail, setConfirmEmail] = useState(false);
  const [confirmEmailReset, setConfirmEmailReset] = useState(false);
  const [showLogin, setShowLogin] = useState(true);
  const [passwordMigrationCommonDomain, setPasswordMigrationCommonDomain] = useState<ICommonDomain>(null);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { userService } = useContext(ServiceContext);
  const authContext = useContext(AuthContext);

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    userService.getMigrationPasswordChange()
      .then(commonDomain => {
        setPasswordMigrationCommonDomain(commonDomain);
      });
  }, []);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    const userAlreadyResetPassword = await userService.getUserAlreadyResetPassword(email);
    authContext.signInOfficer(email, password)
      .then(async () => {
        if (passwordMigrationCommonDomain?.isActive && !userAlreadyResetPassword) {
          await userService.setUserAlreadyResetPassword(email);
        }
      }).catch(async (err) => {
        if (err.code === "UserNotConfirmedException") {
          setConfirmEmail(true);
          setShowLogin(false);
        } else if (err.code === "PasswordResetRequiredException") {
          setConfirmEmailReset(true);
          setShowLogin(false);
        } else if (err.challengeName === "NEW_PASSWORD_REQUIRED") {
          setNewPasswordRequiredUser(err);
          setPasswordRequired(true);
          setShowLogin(false);
        } else {
          if (err.message !== "Usuário Inativo") {
            if (passwordMigrationCommonDomain?.isActive && !userAlreadyResetPassword) {
              authContext.resetPasswodCognito(email);
              setShowResetPasswordModal(true);
            } else {
              ShowNotification.Error("Falha ao entrar", err.response.data)
            }
          } else if (err.message === "Usuário Inativo") {
            ShowNotification.Error("Usuário Inativo", "Por favor, contatar administração.")
          }
        }
      }).finally(() => {
        setLoading(false);
      })
  }

  async function onRequestRecoveryConfirmed(newPass) {
    userService.setUserAlreadyResetPassword(email).then(resp => {
      if (resp) {
        authContext.signInOfficer(email, newPass);
      }
    }).catch((err) => {
      ShowNotification.Error("Falha ao entrar", "Não foi possí­vel entrar com as informações fornecidas, por favor, verifique e tente novamente.");
    })
  }

  return (
    <>
      <Modal
        className="modal-change-password-warning"
        title={passwordMigrationCommonDomain?.content?.title}
        visible={showResetPasswordModal}
        onOk={() => setShowResetPasswordModal(false)}
        closable={false}
        footer={[
          <Button key="ok-button" type="primary" onClick={() => setShowResetPasswordModal(false)}>Ok</Button>
        ]}
      >
        <p>{passwordMigrationCommonDomain?.content?.message}</p>
      </Modal>
      <div style={{ backgroundColor: "#262626", minHeight: "100vh" }}>
        {(confirmEmail && (
          <div className="decode-confirm-page">
            <EmailConfirm email={email} password={password} />
          </div>
        )) ||
          (confirmEmailReset && (
            <div className="decode-confirm-page">
              <ChangePasswordByCode email={email} />
            </div>
          )) ||
          (passwordRequired && (
            <ChangePasswordRequired
              user={newPasswordRequiredUser}
              pass={password}
              onConfirmed={onRequestRecoveryConfirmed}
            />
          )) ||
          (showLogin && (
            <ContainerWrapper className="login">
              <div className="content-align">
                <PbrCard style={{ padding: "30px" }}>
                  <Row align="middle" justify="center">
                    <Col className="preca-br-logo">
                      <div className="logo">
                        <img src={LogoText} />
                        <span className="portal-text">parceiros</span>
                      </div>
                    </Col>
                  </Row>
                  <h2 className="decode-login__title">Bem vindo ao portal de parceiros precatóriosbrasil entre com sua conta.</h2>
                  <Arrow styles={{ width: "20px", position: "relative", left: "calc(99%/2)", transform: "translateX(-49%) rotate(90deg)", fill: "#3d81ff" }} />
                  <Form onSubmit={e => handleSubmit(e)} className="login-form">
                    <PbrInput
                      autoComplete="new-mail"
                      style={{ color: "#222" }}
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      name="email"
                      title="Informe um e-mail válido"
                      placeholder="E-mail"
                      formWrapper={props.form}
                      rules={[
                        {
                          required: true,
                          message: "Informe um e-mail",
                          pattern: emailRegex
                        }
                      ]}
                    />
                    <div style={{ position: 'relative' }}>
                      <PbrInput
                        autoComplete="new-password"
                        style={{ color: "#222" }}
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        name="senha"
                        type={showPassword ? 'text' : 'password'}
                        title="Informe a sua senha"
                        placeholder="Senha"
                        formWrapper={props.form}
                        rules={[
                          {
                            required: true,
                            message: "Informe a senha"
                          }
                        ]}
                      />
                      <Button
                        onClick={handleShowPassword}
                        style={{
                          position: 'absolute',
                          top: 1,
                          right: 1,
                          border: 'none'
                        }}
                        icon={showPassword ? "eye-invisible" : "eye"}
                      />
                    </div>

                    <Row className="actions-btn-row" gutter={16}>
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <StandardButton style={{ maxWidth: "324px" }} loading={loading} type="primary" htmlType="submit">
                          Entrar
                        </StandardButton>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24} className="col-registry">
                        <span style={{ fontFamily: "Lato", fontWeight: 400, textTransform: "uppercase", fontSize: "18px", letterSpacing: "1px" }}>
                          <Link to="/password-recover">Esqueci a senha</Link>
                        </span>
                      </Col>
                    </Row>

                    <ParagraphMedium style={{ textAlign: "center", margin: "40px 0 0", color: "#75889A", fontFamily: "Lato" }}>Precisa de ajuda para acessar?</ParagraphMedium>
                    <ParagraphMedium style={{ textAlign: "center", margin: 0, color: "#75889A", fontFamily: "Lato" }}>
                      Mande um e-mail para
                      <a href="mailto:contato@precatoriosbrasil.com"> contato@precatoriosbrasil.com</a>
                    </ParagraphMedium>
                  </Form>
                </PbrCard>
              </div>
            </ContainerWrapper>
          ))}
      </div>
    </>
  );
}
export default withRouter(Form.create()(Login));



// WEBPACK FOOTER //
// ./src/pages/login/Login.tsx